export enum OfferApplicantStatus {
    "EMAIL_NOT_VALIDATED" = "EMAIL_NOT_VALIDATED",
    "EMAIL_VALIDATED_DRAFT" = "EMAIL_VALIDATED_DRAFT",
    "SUBMITTED_TO_IA" = "SUBMITTED_TO_IA",
    "REJECTED_BY_IA" = "REJECTED_BY_IA",
    "SHORTLISTED_BY_IA"  = "SHORTLISTED_BY_IA",
    "REJECTED_BY_HR_QUESTIONNAIRE" = "REJECTED_BY_HR_QUESTIONNAIRE",
    "SHORTLISTED_BY_HR_QUESTIONNAIRE" = "SHORTLISTED_BY_HR_QUESTIONNAIRE",
    "SHORTLISTED_BY_TECHNICAL_QUESTIONNAIRE" = "SHORTLISTED_BY_TECHNICAL_QUESTIONNAIRE",
    "REJECTED_BY_TECHNICAL_QUESTIONNAIRE" = "REJECTED_BY_TECHNICAL_QUESTIONNAIRE",
    "UNDER_FINAL_REVIEW" = "UNDER_FINAL_REVIEW",
    "REJECTED_AFTER_FINAL_REVIEW" = "REJECTED_AFTER_FINAL_REVIEW",
    "ACCEPTED_AFTER_FINAL_REVIEW" = "ACCEPTED_AFTER_FINAL_REVIEW",
    "OFFER_SENT" = "OFFER_SENT",
    "OFFER_REJECTED_BY_CANDIDATE" = "OFFER_REJECTED_BY_CANDIDATE",
    "OFFER_ACCEPTED_BY_CANDIDATE" = "OFFER_ACCEPTED_BY_CANDIDATE",
    "CONTRACT_SENT" = "CONTRACT_SENT",
    "HIRED" = "HIRED",
}

export const POST_SHORTLIST_STATUSES = [
    OfferApplicantStatus.SHORTLISTED_BY_IA, 
    OfferApplicantStatus.REJECTED_BY_HR_QUESTIONNAIRE, 
    OfferApplicantStatus.SHORTLISTED_BY_HR_QUESTIONNAIRE, 
    OfferApplicantStatus.SHORTLISTED_BY_TECHNICAL_QUESTIONNAIRE, 
    OfferApplicantStatus.REJECTED_BY_TECHNICAL_QUESTIONNAIRE,
    OfferApplicantStatus.REJECTED_AFTER_FINAL_REVIEW, 
    OfferApplicantStatus.UNDER_FINAL_REVIEW, 
    OfferApplicantStatus.ACCEPTED_AFTER_FINAL_REVIEW,
    OfferApplicantStatus.OFFER_SENT,
    OfferApplicantStatus.OFFER_ACCEPTED_BY_CANDIDATE,
    OfferApplicantStatus.OFFER_REJECTED_BY_CANDIDATE,
    OfferApplicantStatus.CONTRACT_SENT,
    OfferApplicantStatus.HIRED, 
];

export const POST_SHORTLISTED_BY_HR_QUESTIONNAIRE_STATUSES = [
    OfferApplicantStatus.SHORTLISTED_BY_HR_QUESTIONNAIRE, 
    OfferApplicantStatus.REJECTED_BY_TECHNICAL_QUESTIONNAIRE,
    OfferApplicantStatus.SHORTLISTED_BY_TECHNICAL_QUESTIONNAIRE,
    OfferApplicantStatus.REJECTED_AFTER_FINAL_REVIEW, 
    OfferApplicantStatus.UNDER_FINAL_REVIEW,
    OfferApplicantStatus.ACCEPTED_AFTER_FINAL_REVIEW,
    OfferApplicantStatus.OFFER_SENT,
    OfferApplicantStatus.OFFER_ACCEPTED_BY_CANDIDATE,
    OfferApplicantStatus.OFFER_REJECTED_BY_CANDIDATE,
    OfferApplicantStatus.CONTRACT_SENT,
    OfferApplicantStatus.HIRED, 
];

export const SHORTLISTED_BY_TECHNICAL_QUESTIONNAIRE = [
    OfferApplicantStatus.SHORTLISTED_BY_TECHNICAL_QUESTIONNAIRE,
    OfferApplicantStatus.REJECTED_AFTER_FINAL_REVIEW,
    OfferApplicantStatus.UNDER_FINAL_REVIEW,
    OfferApplicantStatus.ACCEPTED_AFTER_FINAL_REVIEW,
    OfferApplicantStatus.OFFER_SENT,
    OfferApplicantStatus.OFFER_ACCEPTED_BY_CANDIDATE,
    OfferApplicantStatus.OFFER_REJECTED_BY_CANDIDATE,
    OfferApplicantStatus.CONTRACT_SENT,
    OfferApplicantStatus.HIRED,
];

export const ALL_STATUS_NOT_READ_ONLY = [
    OfferApplicantStatus.EMAIL_NOT_VALIDATED,
    OfferApplicantStatus.EMAIL_VALIDATED_DRAFT,
    OfferApplicantStatus.SUBMITTED_TO_IA
];

export const POST_ACCEPTED_FINAL_REVIEW_STATUSES = [
    OfferApplicantStatus.ACCEPTED_AFTER_FINAL_REVIEW,
    OfferApplicantStatus.OFFER_SENT,
    OfferApplicantStatus.OFFER_ACCEPTED_BY_CANDIDATE,
    OfferApplicantStatus.OFFER_REJECTED_BY_CANDIDATE,
    OfferApplicantStatus.CONTRACT_SENT,
    OfferApplicantStatus.HIRED,
];

export const POST_OFFER_SENT_STATUSES = [
    OfferApplicantStatus.OFFER_SENT,
    OfferApplicantStatus.OFFER_ACCEPTED_BY_CANDIDATE,
    OfferApplicantStatus.OFFER_REJECTED_BY_CANDIDATE,
    OfferApplicantStatus.CONTRACT_SENT,
    OfferApplicantStatus.HIRED,
];

export const POST_OFFER_ACCEPTED_BY_CANDIDATE_STATUSES = [
    OfferApplicantStatus.OFFER_ACCEPTED_BY_CANDIDATE,
    OfferApplicantStatus.CONTRACT_SENT,
    OfferApplicantStatus.HIRED,
];

export const POST_CONTRACT_SENT_STATUSES = [
    OfferApplicantStatus.CONTRACT_SENT,
    OfferApplicantStatus.HIRED,
];